export const flowTaskGroups = [
  { id: 'group_01', value: 'Group 01', color: '#1e3d59' },
  { id: 'group_02', value: 'Group 02', color: '#40236b' },
  { id: 'group_03', value: 'Group 03', color: '#1868ae' },
  { id: 'group_04', value: 'Group 04', color: '#1e847f' },
  { id: 'group_05', value: 'Group 05', color: '#c9d7eb' },
  { id: 'group_06', value: 'Group 06', color: '#ecc19c' },
  { id: 'group_07', value: 'Group 07', color: '#ff9a8d' },
  { id: 'group_08', value: 'Group 08', color: '#ed3572' },
  { id: 'group_09', value: 'Group 09', color: '#ff6e40' },
  { id: 'group_10', value: 'Group 10', color: '#ffc13b' }
]
